export { default } from './Hot'
